module.exports = __webpack_public_path__ + "assets/geral.4120a0d1.svg";